import { render } from "./WorkflowVideoReviewDialog.vue?vue&type=template&id=c5e77416&ts=true"
import script from "./WorkflowVideoReviewDialog.vue?vue&type=script&lang=ts"
export * from "./WorkflowVideoReviewDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__